import { render, staticRenderFns } from "./AdSpaceEdit.vue?vue&type=template&id=2db05a64&scoped=true&"
import script from "./AdSpaceEdit.vue?vue&type=script&lang=ts&"
export * from "./AdSpaceEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpaceEdit.vue?vue&type=style&index=0&id=2db05a64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db05a64",
  null
  
)

export default component.exports